import React from 'react'

import {
  TableContainerStyled,
  TableStyled,
  TableHeadStyled,
  TableRowStyled,
  TableCellStyled,
  TableBodyStyled,
  TableFooter
} from 'components'
import { useTabs } from 'hooks'
import { IHandleChangePage, IHandleChangeRowsPerPage } from 'hooks/useGet'
import { IPaginatedEntityGST } from 'services/core/genericEntityGST'
import { IGraduacaoMultasGetAllResponse } from 'services/GST/GraduacaoMultas'

import { useFineGraduation } from '../../../../context'

interface ISearchTableProps {
  data: IPaginatedEntityGST<IGraduacaoMultasGetAllResponse[]>
  page: number
  rowsPerPage: number
  handleChangeRowsPerPage: IHandleChangeRowsPerPage
  handleChangePage: IHandleChangePage
}

const GraduacaoDeMultasTable: React.FC<ISearchTableProps> = ({
  data,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage
}) => {
  const { handleChangeTab } = useTabs()
  const { handleSelectMulta } = useFineGraduation()

  const handleChangeMulta = (multa: IGraduacaoMultasGetAllResponse) => {
    handleSelectMulta(multa)
    handleChangeTab(null, 1)
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="center" minwidth="20px">
                Área de Atuação
              </TableCellStyled>
              <TableCellStyled align="center" minwidth="20px">
                Número de Funcionários
              </TableCellStyled>
              <TableCellStyled align="center" minwidth="20px">Infração</TableCellStyled>
              <TableCellStyled align="center" minwidth="50px">
                Quantidade UFIR
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {data?.entity?.items?.map((row) => (
              <TableRowStyled
                key={`${row.idGradacaoMulta}`}
                onClick={() => handleChangeMulta(row)}
              >
                <TableCellStyled align="center">{row.txAreaAtuacao || '---'}</TableCellStyled>
                <TableCellStyled align="center">
                  {row.txNumeroFuncionarios || '---'}
                </TableCellStyled>
                <TableCellStyled align="center">{row.txInfracao || '---'}</TableCellStyled>
                <TableCellStyled align="center">
                  {row.qtdUFIR || '---'}
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        totalItems={data?.entity?.pageCount}
        rows={data?.entity?.items}
        typeFooter="online"
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}

export default GraduacaoDeMultasTable
